import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Accordion from '@mui/material/Accordion';

const StyledAccordion = styled(Accordion)`
  .AccordionSummary {
    .MuiAccordionSummary-expandIconWrapper {
      color: inherit;
    }
    
    ${props => props.theme.state2Selector('AccordionSummary', null, ['focusVisible'])} {
      background-color: unset;
      color: ${props => props.theme.property('palette.primary.main')};
    }
  }
    
  &.Accordion-density-dense {
    .AccordionSummary {
      padding: 0;
      min-height: ${props => props.theme.layout(36)};
      .MuiAccordionSummary-content {
        margin: ${props => props.theme.layout('1sp')} 0;
      }
    }
  }

  &.Accordion-density-denser {
    .AccordionSummary {
      padding: 0;
      min-height: ${props => props.theme.layout(36)};
      .MuiAccordionSummary-content {
        margin: ${props => props.theme.layout('0.5sp')} 0;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledAccordion.propTypes = {
  theme: PropTypes.object
};

export default StyledAccordion;
